<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img
        class="pointer"
        @click="clickLocalStep()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 活动条件表单设置 -->
      <div class="secondstep">
        <!-- 头部提示 -->
        <div class="card-point">
          <div class="card-rule">
            <i
              class="el-alert__icon el-icon-info"
              style="color: #2670fb; margin-right: 3px"
            ></i>
            说明：
          </div>
          <div class="card-connet">
            <p>1、订单完成后发放奖励。</p>
          </div>
        </div>

        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm"
          ref="ruleForm"
          label-width="120px"
        >
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input
              v-model="ruleForm.activityName"
              maxlength="50"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 340px"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 340px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="activityTimeValue = []"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天
              <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动有效期不可超过订购有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="backgroundOpacity || isStartEdit"
              @change="handleActivityObj"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
                placement="right-start"
                trigger="hover"
                content="您不满足使用该功能的条件，请联系专属客服了解~"
              >
                <el-button slot="reference" disabled style="margin-left:16px">{{
                  peopleList.length == 0
                    ? "选择人群"
                    : `已选${peopleList.length}个`
                }}</el-button>
              </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="backgroundOpacity || isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="light" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #ccc;
                "
              >
                <span style="color:#999">新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="backgroundOpacity || isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="backgroundOpacity || isStartEdit"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

          <el-form-item label="活动条件:">
            <!-- prop="isFollow" 是否关注店铺 -->
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
              :disabled="isStartEdit"
            ></el-checkbox>
          </el-form-item>
          <el-form-item label="抽奖条件:" required>
            <!-- <span>下单付款后即可参与活动（预售商品需要支付尾款才可参与活动）</span> -->
            <div class="rule_box">
              <div class="rule_box_top">所下订单需满足如下条件</div>
              <!-- 抽奖规则新增付款完成状态也可抽奖 -->
              <div class="rule_box_top">
                <span> 订单抽奖状态： </span>
                <span style="display: inline-block">
                  <el-radio-group
                    v-model="unlockTradeStatus"
                    @change="unlockTradeStatusChange"
                    :disabled="isStartEdit"
                  >
                    <el-radio label="0">已付款</el-radio>
                    <el-radio label="1">交易完成</el-radio>
                  </el-radio-group>
                </span>
              </div>

              <div class="rule_box_middle">
                <el-form-item label="下单时间:" required>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="
                        orderLotteryActivityPartakeRule.lotteryCondition
                          .orderStartTime
                      "
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 120px; font-size: 12px"
                      class="time1"
                      @change="orderStartTimeChange"
                      :clearable="false"
                      :disabled="isStartEdit"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="
                        orderLotteryActivityPartakeRule.lotteryCondition
                          .orderEndTime
                      "
                      default-time="23:59:59"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 145px; font-size: 12px"
                      class="time2"
                      @change="orderStartTimeChange"
                      :clearable="false"
                      :disabled="isStartEdit"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      @click="clearTime(1)"
                    ></i>
                    <img
                      src="@/assets/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                </el-form-item>
                <el-form-item label="商品件数:" required>
                  <el-input
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderNumLower
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    @input="
                      orderLotteryActivityPartakeRule.lotteryCondition.orderNumLower =
                        getNumberData($event, 0)
                    "
                    :disabled="isStartEdit"
                  ></el-input
                  >&nbsp; 件- &nbsp;
                  <el-input
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderNumUpper
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    @input="
                      orderLotteryActivityPartakeRule.lotteryCondition.orderNumUpper =
                        getNumberData($event, 0)
                    "
                    :disabled="isStartEdit"
                  ></el-input
                  >&nbsp; 件
                </el-form-item>
                <el-form-item label="订单金额:" required>
                  <el-input
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderPriceLower
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    @input="
                      orderLotteryActivityPartakeRule.lotteryCondition.orderPriceLower =
                        getNumberData($event, 1)
                    "
                    :disabled="isStartEdit"
                  ></el-input
                  >&nbsp; 元- &nbsp;
                  <el-input
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .orderPriceUpper
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    @input="
                      orderLotteryActivityPartakeRule.lotteryCondition.orderPriceUpper =
                        getNumberData($event, 1)
                    "
                    :disabled="isStartEdit"
                  ></el-input
                  >&nbsp; 元<span style="color: red; margin-left: 10px"
                    >注意：该订单金额为实付金额</span
                  >
                </el-form-item>
              </div>
              <div class="rule_box_bottom">
                <el-form-item label="指定购买商品:" required>
                  <el-radio
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .specifyGoods
                    "
                    :label="0"
                    :disabled="isStartEdit"
                    >全部商品</el-radio
                  >
                  <el-radio
                    v-model="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .specifyGoods
                    "
                    :label="1"
                    :disabled="isStartEdit"
                    >指定商品</el-radio
                  >
                  <el-button
                    :disabled="isStartEdit"
                    :style="{
                      width: selectGoodsArr.length > 0 ? '110px' : '60px',
                      margin: ' 0 0px 0 15px',
                    }"
                    @click="exposureProducts"
                    v-if="
                      orderLotteryActivityPartakeRule.lotteryCondition
                        .specifyGoods == 1
                    "
                  >
                    {{
                      selectGoodsArr.length != ""
                        ? "+添加" + "(" + selectGoodsArr.length + ")"
                        : "+添加"
                    }}
                  </el-button>
                  <el-button
                    :style="{
                      width: selectGoodsArr.length > 0 ? '110px' : '60px',
                      margin: ' 0 0px 0 15px',
                    }"
                    disabled
                    v-else
                  >
                    +添加
                  </el-button>
                </el-form-item>
              </div>
            </div>
            <div
              style="
                margin: 12px 0 0 0px;
                color: #666666;
                background: #f4f7ff;
                border-radius: 4px;
                width: 525px;
                padding: 5px 15px;
              "
            >
              <i
                class="el-alert__icon el-icon-info"
                style="color: #2670fb; margin-right: 0px"
              ></i>
              注：订单完成后发放奖励。整个活动期内每人只可参与1次,抽奖次数可自定义
            </div>
          </el-form-item>

          <el-form-item label="抽奖和中奖限制:">
            <div class="limit">
              <p>
                每人<span class="c"></span>可抽奖次数
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="
                    orderLotteryActivityPartakeRule.winningCondition
                      .drawPerPersonNum
                  "
                  placeholder="请输入..."
                  @input="
                    orderLotteryActivityPartakeRule.winningCondition.drawPerPersonNum =
                      getNumberData($event, 0)
                  "
                  style="width: 70px"
                ></el-input>
                次
                <el-tooltip
                  class="item"
                  effect="light"
                  content="解锁订单成功获取的抽奖次数，活动期间，多个订单符合，只能使用其中1个订单解锁1次。"
                  placement="bottom"
                >
                  <i
                    class="el-icon-question"
                    style="margin-left: 10px; cursor: pointer; color: #ccc"
                  ></i>
                  <!-- <i class="el-icon-question"></i> -->
                </el-tooltip>
              </p>
              <p>
                活动期间每人<span class="c"></span>中奖不超过
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="
                    orderLotteryActivityPartakeRule.winningCondition
                      .winningNoMoreThanNum
                  "
                  placeholder="请输入..."
                  style="width: 70px"
                  @input="
                    orderLotteryActivityPartakeRule.winningCondition.winningNoMoreThanNum =
                      getNumberData($event, 0)
                  "
                ></el-input>
                次
              </p>
              <!-- <p class="desc">
                <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:0px"></i>
                
              </p> -->
              <div
                style="
                  margin: 12px 0 0 0px;
                  color: #666666;
                  background: #f4f7ff;
                  border-radius: 4px;
                  width: 511px;
                  padding: 5px 15px;
                "
              >
                <i
                  class="el-alert__icon el-icon-info"
                  style="color: #2670fb; margin-right: 0px"
                ></i>
                注：此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
              </div>
            </div>
          </el-form-item>

          <el-form-item required>
            <span slot="label" class="set">奖品设置:</span>
            <div class="termAdd">
              <el-popover placement="right" width="270" trigger="hover">
                <img
                  src="../../assets/images/integralCenter/wzsyt.png"
                  alt=""
                />
                <span slot="reference">位置示意图</span>
              </el-popover>
              <p>
                累计中奖率: <span class="add">{{ winningRate }} %</span>
              </p>
            </div>
            <el-table
              :data="prizeSettingList"
              style="width: 100%; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#F8F9FF',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span v-if="scope.row.index == 0">一</span>
                  <span v-if="scope.row.index == 1">二</span>
                  <span v-if="scope.row.index == 2">三</span>
                  <span v-if="scope.row.index == 3">四</span>
                  <span v-if="scope.row.index == 4">五</span>
                  <span v-if="scope.row.index == 5">六</span>
                  <span v-if="scope.row.index == 6">七</span>
                  <span v-if="scope.row.index == 7">八</span>
                </template>
              </el-table-column>

              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" @click="centerVis(scope.row)">选奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">专属商品</span>
                </template>
              </el-table-column>

              <el-table-column label="值" width="80" prop="price">
                <!-- <template slot-scope="scope">
                  {{ scope.row.price }}
                </template> -->
              </el-table-column>

              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input
                    :disabled="isStartEdit"
                    v-model="scope.row.title"
                    maxlength="12"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品总数" width="180">
                <template slot-scope="scope">
                  <el-input
                    @blur="beAdd(scope.row)"
                    v-model.number="scope.row.totalAmount"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="scope.row.totalAmount = checkLimitMount(scope.row,1)"
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="每日发放限额" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.dailyLimit"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="scope.row.dailyLimit = checkLimit(scope.row,1)"
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="中奖率">
                <template slot-scope="scope">
                  <el-input
                    :disabled="isStartEdit"
                    v-model="scope.row.percentage"
                    placeholder="请输入..."
                    style="width: 70px"
                    @keyup.native="
                      scope.row.percentage = oninput2(scope.row.percentage)
                    "
                    @input="
                      scope.row.percentage = getNumberData($event, 1, 0, 100)
                    "
                  ></el-input>
                  %
                </template>
              </el-table-column>

              <el-table-column label="图片" width="170">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.logo"
                    :src="scope.row.logo"
                    style="width: 56px; height: 56px"
                  />
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span
                    class="s"
                    style="color: #f56c6c"
                    @click="cleanData(scope.row)"
                    >清除</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="tips">
              <span>
                <i
                  class="el-alert__icon el-icon-info"
                  style="color: #2670fb; margin-right: 3px"
                ></i
                >说明
              </span>
              <p>
                1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
              </p>
              <p>
                2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
              </p>
              <p>3、中奖率精确到小数点后三位，如不想中奖可设置0%</p>
              <p>
                4、实物奖品可上传图片，不上传使用默认图片。已有图片时点击可更换。
              </p>
            </div>
          </el-form-item>

          <el-form-item label="活动规则" required>
            <div style="width: 500px; padding: 8px; background: #f9fafb">
              <el-input
                maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                :disabled="backgroundOpacity"
              ></el-input>

              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                  :disabled="backgroundOpacity"
                  >生成规则</el-button
                >
                <span class="desc">
                  <i
                    class="el-alert__icon el-icon-info"
                    style="color: #999"
                  ></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>
          <div
            v-if="backgroundOpacity"
            class="backgroundOpacity"
            style="height: calc(100% - 45px)"
          ></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <el-button
        v-show="!itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="resetForm"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button
        v-show="itemId"
        class="createBtn create_bottom_keepBtn"
        type="primary"
        size="medium"
        >保存设置</el-button
      >
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      :num="1"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      @choose-shop="getTheData"
    >
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 添加曝光商品 -->
    <!-- <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
    ></selectGoodsMonitor> -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>
  </div>
</template>

<script>
import selectProduct from "./select_product";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
import {
  bigTurntableDraw,
  bigTurntableDraw2,
  modifyBigTurn,
  getbigTurn,
  getOrderDraw,
} from "@/api/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/analysis/ware-controller";

import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
import { publicOpen } from "@/api/public";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";

export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
  },
  // props: {
  //   itemId: "",
  //   stepNum: {
  //     type: Number,
  //     default: 0,
  //   },
  //   activityData: {
  //     type: Object,
  //   },
  //   ids: {
  //     type: String,
  //     default: "",
  //   },
  //   isSave: {
  //     type: Boolean,
  //     default: true,
  //   },
  //   backgroundOpacity: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  computed: {
    ...mapState(["venderType"]),
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(3);
    },
  },
  data() {
    return {
      isStartEditTime:'',
      isStartEdit:false,
      unlockTradeStatus: '1',
      isCopy: false,
      labelListDatas: [
        {
          id: '0',
          labelName: "已付款",
        },
        {
          id: '1',
          labelName: "交易完成",
        },
      ],
      generalCoupon: {
        // 通用优惠券
        couponType: 0,
      },
      ids: "",
      telCode: "",
      valueRow: null,
      localStep: 1,
      statusComment: false,
      localStepNum: 1,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.$store.state.loginUserInfo.expiredIn).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },

      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
      },
      ruleForm: {
        membershipTime:"",
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",

        activityObject: 0, //活动对象
        newOldCustomer: 0, //新老客
        partner: ["-1"],

      },
      peopleList: [], //指定人群
      isShowSelectCrowd: false, //指定人群弹窗
      levelList: [], //会员等级

      bigTurntable: {
        point: null,
        oneDayMaxDrawNumber: null,
        totalMaxDrawNumber: null,
        oneDayMaxRewardNumber: null,
        totalMaxRewardNumber: null,
      },
      // 抽奖条件
      orderLotteryActivityPartakeRule: {
        lotteryCondition: {
          orderEndTime: null,
          orderNumLower: "",
          orderNumUpper: "",
          orderPriceLower: "",
          orderPriceUpper: "",
          orderStartTime: null,
          skuIds: [],
          specifyGoods: 0,
        },
        winningCondition: {
          drawPerPersonNum: null,
          winningNoMoreThanNum: null,
        },
      },
      bigTurntableDrawS: [
        // {
        //   assetsId: 0,
        //   logo: "string",
        //   giftType: 0,
        //   logo: "string",
        //   percentage: 0,
        //   price: 0,
        //   prizeType: 0,
        //   singleAmount: 0,
        //   title: "string",
        //   totalAmount: 0,
        // },
      ],
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
      ],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      jdCrm: {
        startTime: "",
        endTime: "",
        isCrm: false,
      },
    };
  },
  mounted() {
    this.activityData = this.$route.query.activityData;
    console.log('this.$route.query------>', this.$route.query)
    if (this.$route.query.valueRow) {
      this.backgroundOpacity =
      this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment =
      this.$route.query.statusComment == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.ids = this.valueRow.id;
    } else if (this.$route.query.copyParams) { // 复制
      this.isCopy = true
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.ids = this.valueRow.id;
    } else {
    }
    this.getDetail();
    this.getLevel()
  },

  methods: {
    unlockTradeStatusChange(e) {
      this.unlockTradeStatus =e;
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // //下边写用户输入时需要的执行逻辑
        // if(this.ruleForm.inputprize!= filtered) {
        //     this.ruleForm.inputprize = filtered
        // }
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (row.quantityTotal && row.price && row.totalAmount) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    checkLimitMount(row,min) {
      let newVal = (row.totalAmount+ "").replace(/[^\d]/g, '')
        if(newVal) {
          if(newVal<min) {
            return ""
          }else {
            if(Number(row.dailyLimit) > Number(row.totalAmount)) {
              this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
             return
            } else {
              return Number(row.totalAmount)
            }
          }
        }
    },
    checkLimit(row,min) {
        let newVal = (row.dailyLimit+ "").replace(/[^\d]/g, '')
        if(newVal) {
          if(newVal<min) {
            return ""
          }else {
            if(Number(row.dailyLimit) > Number(row.totalAmount)) {
              this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
              return ""
            } else {
              return Number(row.dailyLimit)
            }
          }
        }
    },
    //上传图片
    handleChange(file, fileList) {
      console.log(file, fileList, 333333);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() {},
    //生成规则
    generateRule() {
      let oldValue = this.ruleForm;
      let order = this.orderLotteryActivityPartakeRule;
      let orderText1 = "";
      let orderText2 = "";
      let orderText3 = "";
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 =
          "活动时间：" + this.ruleForm.startTime + "-" + this.ruleForm.endTime;
      }
      if (this.ruleForm.condFollow == true) {
        text3 = "活动条件：关注店铺后方可参加活动";
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      // 下单时间
      if (
        order.lotteryCondition.orderEndTime &&
        order.lotteryCondition.orderStartTime
      ) {
        orderText1 =
          "抽奖条件：下单时间：" +
          order.lotteryCondition.orderStartTime +
          "~" +
          order.lotteryCondition.orderEndTime +
          ";";
      }
      // 商品件数
      if (
        order.lotteryCondition.orderNumLower.toString() &&
        order.lotteryCondition.orderNumUpper.toString()
      ) {
        orderText2 =
          "商品件数:" +
          order.lotteryCondition.orderNumLower +
          "件~" +
          order.lotteryCondition.orderNumUpper +
          "件;";
      }
      // 订单金额：
      if (
        order.lotteryCondition.orderPriceLower.toString() &&
        order.lotteryCondition.orderPriceUpper.toString()
      ) {
        orderText3 =
          "订单金额：" +
          order.lotteryCondition.orderPriceLower +
          "元~" +
          order.lotteryCondition.orderPriceUpper +
          "元";
      }
      text4 = orderText1 + orderText2 + orderText3;

      if (order.winningCondition.drawPerPersonNum) {
        text5 =
          "每人可抽奖次数" + order.winningCondition.drawPerPersonNum + "次";
      }
      if (order.winningCondition.winningNoMoreThanNum) {
        text6 =
          "活动期间每人中奖不超过" +
          order.winningCondition.winningNoMoreThanNum +
          "次";
      }
      let Arr1 = [text1, text2, text3,text34, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.ruleDescription = newText;
    },

    // 活动进行中修改奖品数量
    beAdd(row){
      console.log("活动进行中修改奖品数量",row);
      if(this.isStartEdit){
        if(row.minNum && Number(row.totalAmount) < Number(row.minNum)){
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },

    //清除
    cleanData(row) {
      if(this.isStartEdit) return;
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.dailyLimit = null;
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(3);
      }
    },
    //选择奖品弹窗
    centerVis(row) {
      if(this.isStartEdit) return;
      this.$refs.selectProduct.openDialog();
      this.index = row.index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.$refs.selectProduct.physicalGift(row)
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, 2233);
      if (data.couponType == 4) {
        this.generalCoupon = JSON.parse(JSON.stringify(data));
      } else {
        this.generalCoupon = { couponType: 0 };
      }
      // console.log(this.index, 1111111111111);
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        if (data.couponType == 4) {
          this.prizeSettingList[this.index].batchKey = data.batchKey;
        }
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      if (data.couponType == 4) {
        this.prizeSettingList[this.index].price = Number(data.price);
      } else {
        this.prizeSettingList[this.index].price = Number(data.discount);
      }

      if (data.couponType == 4) {
        this.prizeSettingList[this.index].assetsId = null;
      } else {
        this.prizeSettingList[this.index].assetsId = Number(data.couponId);
      }

      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = "店铺积分";
      } else {
        if (data.couponType == 4) {
          this.prizeSettingList[this.index].title = "优惠券";
        } else {
          this.prizeSettingList[this.index].title = data.name;
        }
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 10) {
        this.prizeSettingList[this.index].price = data.price;
        this.prizeSettingList[this.index].title =
          data.itemTitle.length >= 12
            ? data.itemTitle.substring(0, 12)
            : data.itemTitle;
        this.prizeSettingList[this.index].logo = data.picUrl;
        this.prizeSettingList[this.index].assetsId = data.id;
        this.prizeSettingList[this.index].singleAmount = 1;
      }
      // 订单备注开启单独处理，只针对下单抽奖
      if (prizeType == 3 && data.prizeRemarkType && this.activityData.id == 19) {
        this.prizeSettingList[this.index].prizeRemarkType = data.prizeRemarkType;
        this.prizeSettingList[this.index].receivePayment = data.receivePayment;
        this.prizeSettingList[this.index].remarkActionType = data.remarkActionType;
        if(data.remarkActionType == '1'){
          this.prizeSettingList[this.index].startCreateTradeTimeForManualLinkTrade = data.startCreateTradeTimeForManualLinkTrade;
          this.prizeSettingList[this.index].endCreateTradeTimeForManualLinkTrade = data.endCreateTradeTimeForManualLinkTrade;
        }else{
          this.prizeSettingList[this.index].tradeLimitTime = data.tradeLimitTime;
          this.prizeSettingList[this.index].tradeLimitTimeUnit = data.tradeLimitTimeUnit;
        }
        this.prizeSettingList[this.index].itemType = data.itemType;
        this.prizeSettingList[this.index].tradeFlag = data.tradeFlag;
        this.prizeSettingList[this.index].content = data.content;

        if (data.itemType) {
          const arr = data.goodsList.map(item => item.wareId)
          this.prizeSettingList[this.index].numIid = arr.join(",");
        } else {
          this.prizeSettingList[this.index].numIid = "";
        }
      }
      console.log(this.prizeSettingList, 123);
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      console.log(this.prizeSettingList, "obj");
      let order = this.orderLotteryActivityPartakeRule;
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      // if (!this.bigTurntable.point) {
      //   this.$message.warning("请输入抽奖条件");
      //   return;
      // }
      if (
        !(
          order.lotteryCondition.orderEndTime &&
          order.lotteryCondition.orderNumLower.toString() &&
          order.lotteryCondition.orderNumUpper.toString() &&
          order.lotteryCondition.orderPriceLower.toString() &&
          order.lotteryCondition.orderPriceUpper.toString() &&
          order.lotteryCondition.orderStartTime
        )
      ) {
        this.$message.warning("请输入抽奖条件");
        return;
      }
      // if(this.orderLotteryActivityPartakeRule.specifyGoods == '1' && this.orderLotteryActivityPartakeRule.skuIds) {
      //   this.$message.warning("请至少选择一件指定商品");
      //   return;
      // }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      this.joinBlackList = true;
    },
    handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.seniorGroupId = this.peopleList.join(","), //指定人群
      obj.allowLevel = this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,

      obj.orderLotteryActivityPartakeRule =
        this.orderLotteryActivityPartakeRule;
      obj.orderLotteryActivityPartakeRule.lotteryCondition.skuIds = [];
      obj.integralParadisePrizeDTOS = this.deepClone(this.prizeSettingList);
      obj.orderLotteryActivityPartakeRule.lotteryCondition.unlockTradeStatus = this.unlockTradeStatus
      //订单状态数据添加传字符串的格式
      if (
        this.orderLotteryActivityPartakeRule.lotteryCondition.specifyGoods == 1
      ) {
        // this.selectGoodsArr.forEach((e) => {
        //   // obj.orderLotteryActivityPartakeRule.lotteryCondition.skuIds.push(e.skuId);
        // });
        obj.orderLotteryActivityPartakeRule.lotteryCondition.skuIds =
          this.selectGoodsArr.map((item) => {
            return {
              logo: item.logo,
              jdPrice: item.price,
              skuName: item.title,
              skuId: item.skuId,
              wareId: item.numIid,
            };
          });
      }
      obj.integralParadisePrizeDTOS.forEach((item, index) => {
        item.percentage = Number(item.percentage);
        item.totalAmount = !item.isWrite ? (item.totalAmount ? item.totalAmount : "") : undefined;
      });
      if (this.checked == true) {
        if (this.activityData.id == 19) {
          obj.templateId = this.activityData.templateId;
        }
        if (this.isCopy) {
          delete obj.id
          delete obj.templateJson
        }
        console.log('obj------>', obj)
        bigTurntableDraw2(obj)
          .then((res) => {
            if (res && res.code == 1) {
              this.joinBlackList = false;
              this.$router.push({ path: "activeList1" });
              this.$message.success(res.message);
            } else {
              console.log('111111');
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        getOrderDraw(id)
          .then((res) => {
            // 指定商品回显
            let skuIdsLength =
              res.data.orderLotteryActivityPartakeRule.lotteryCondition.skuIds
                .length;
            let skuIds =
              res.data.orderLotteryActivityPartakeRule.lotteryCondition.skuIds.toString();
            // getTaobaoItemListSku({ current: 1, size: skuIdsLength, skuIds: skuIds }).then((res) => {
            //   this.selectGoodsArr = res.data.records;
            // });
            this.selectGoodsArr =
              res.data.orderLotteryActivityPartakeRule.lotteryCondition.skuIds.map(
                (item) => {
                  return {
                    ...item,
                    numIid: item.wareId,
                    itemTitle: item.skuName,
                    picUrl: item.logo,
                    price: item.jdPrice,
                    title: item.skuName,
                  };
                }
            );
            res.data.partner = ['-1']; //解决点击无反应
            this.ruleForm = res.data;
            if (this.isCopy) {
              this.ruleForm.ruleDescription = ""
            }
            this.ruleForm.condFollow = Boolean(res.data.condFollow);
            //活动对象
            this.ruleForm.membershipTime = res.data.membershipTime
            this.ruleForm.activityObject = res.data.activityObject || 0;
            this.ruleForm.newOldCustomer = res.data.newOldCustomer || 0;
            this.peopleList = res.data.seniorGroupId
             ? res.data.seniorGroupId.split(",")
             : [];
             if (res.data.allowLevel) {
             this.ruleForm.partner = res.data.allowLevel.split(",");
            }
            this.bigTurntable = res.data.orderLotteryActivityPartakeRule;
            if (!this.isCopy) {
              this.prizeSettingList = res.data.bigTurntableDrawPrizeDTOS;
              this.prizeSettingList.forEach(item=>item.minNum=item.totalAmount)

              this.prizeSettingList.forEach((item) => {
              if (item.prizeRemarkType) {
                item.prizeRemarkType = item.prizeRemarkType;
                item.receivePayment = item.pointActivityPrizeRemark.receivePayment;
              
                item.itemType = item.pointActivityPrizeRemark.itemType;
                item.tradeFlag = item.pointActivityPrizeRemark.tradeFlag;
                item.content = item.pointActivityPrizeRemark.content;
                item.numIid = item.pointActivityPrizeRemark.numIid;

                item.remarkActionType = item.pointActivityPrizeRemark.remarkActionType;
              
              if(item.pointActivityPrizeRemark.remarkActionType == '1'){
                item.startCreateTradeTimeForManualLinkTrade = item.pointActivityPrizeRemark.startCreateTradeTimeForManualLinkTrade;
                item.endCreateTradeTimeForManualLinkTrade = item.pointActivityPrizeRemark.endCreateTradeTimeForManualLinkTrade;
              }else{
                item.tradeLimitTime = item.pointActivityPrizeRemark.tradeLimitTime;
                item.tradeLimitTimeUnit = item.pointActivityPrizeRemark.tradeLimitTimeUnit;
              }

                delete item.pointActivityPrizeRemark
                }
              });

            } else {
              this.prizeSettingList = [
                // 奖项设置
                {
                  index: 0,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 1,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 2,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 3,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 4,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 5,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 6,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 7,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
              ]
            }
            
            this.orderLotteryActivityPartakeRule =
              res.data.orderLotteryActivityPartakeRule;
              this.prizeSettingList.forEach((item, index) => {
                item.minNum = item.totalAmount
                item.index = index;
                item.isWrite = false;
                if (item.percentage) {
                  this.winningRate += Number(item.percentage);
                }
              });
            // this.prizeSettingList.forEach((item) => {
            //   if (item.percentage) {
            //     this.winningRate += Number(item.percentage);
            //   }
            // });
            this.activityTimeValue = [
              String(res.data.startTime),
              String(res.data.endTime),
            ];

            if(this.isStartEdit){
              //进行中活动 无法修改活动开启时间
              this.isStartEditTime = String(res.data.startTime)
            }

            this.winningRate = this.winningRate.toFixed(3);
             //订单状态回显
            this.unlockTradeStatus = this.ruleForm.orderLotteryActivityPartakeRule.lotteryCondition.unlockTradeStatus
            this.activityTimeChange();
          })
          .catch((res) => {});
      } else {
        this.activityTimeChange();
      }
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch(() => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //活动对象切换
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
    //选择人群回调
    handleConfirm(list) {
      console.log("选择人群", list);
      // let flag = false;
      // list.forEach((item) => {
      //   if (item.buyerNum == 0) {
      //     flag = true;
      //   }
      // });
      // if (flag) {
      //   this.$message.warning("含人群数量为0的人群，请重新选择人群");
      // }
      this.peopleList = list;
    },
    //清空时间
    clearTime(type) {
      if (type == 2) {
        this.ruleForm.startTime = "";
        this.ruleForm.endTime = "";
      } else if (type == 1) {
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderStartTime =
          "";
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime = "";
      }
    },
    // 活动时间改变
    activityTimeChange(val) {
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0]= this.isStartEditTime
      }
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let CRMtime = new Date(this.jdCrm.endTime).valueOf();
      let invalidateDate = new Date(
        this.$store.state.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.startTime.substring(0, 10);
      daysEnd = this.ruleForm.endTime.substring(0, 10);
      if (this.ruleForm.endTime != "" && this.ruleForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (start < nowTime) {
        if (this.ids) {
          this.disableTime = true;
        } else {
          this.$message.warning("开始时间不能小于当前时间");
          // this.ruleForm.startTime = null;
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.endTime = null;
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.activityTimeValue[1] = "";
        this.ruleForm.endTime = null;
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.endTime = null;
        return;
      }
    },
    // 下单时间
    orderStartTimeChange() {
      let start = new Date(
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderStartTime
      ).valueOf();
      let end = new Date(
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime
      ).valueOf();
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.orderLotteryActivityPartakeRule.lotteryCondition.orderEndTime =
          null;
        return;
      }
    },

    // 选择礼品
    choosegifts() {},
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
        if($index==index) {
          item.isWrite = true
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.orderLotteryActivityPartakeRule.skuIds);
      if (this.selectGoodsArr.length == 0) {
        this.selectGoodsArr = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //添加曝光商品弹窗
    selectGoodsClose(event, index) {
      // if (data) {
      //   console.log(data);
      //   let selectGoodsArr = [];
      //   this.mainImagelist = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     selectGoodsArr.push(fomeVaule);
      //     this.mainImagelist.push(fomeVaule);
      //   });
      //   this.selectGoodsArr = selectGoodsArr;
      // }
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      // console.log(this.selectGoodsArr, this.orderLotteryActivityPartakeRule.skuIds, 3333);
      this.selectGoodsState = false;
    },
    // 是否自营
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          var data1 = new Date(res.message);
          var data2 = new Date();
          this.jdCrm.endTime = res.message;
          if (data1.getTime() > data2.getTime()) {
            this.jdCrm.isCrm = true;
          } else {
            this.jdCrm.isCrm = false;
          }
        }
      });
    },
    toCreated() {
      if (sessionStorage.getItem("venderType") == 0) {
        this.localStepNum = 1;
      } else {
        if (this.jdCrm.isCrm) {
          this.localStepNum = 1;
        } else {
          this.$message({
            type: "warning",
            message: "自营店铺需要搭配云短信CRM使用!请联系客服!",
          });
        }
      }
    },
    toCRM() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_blank"
      );
    },
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
      // if (this.backgroundOpacity) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-point {
  width: 100%;
  background: #f4f7ff;
  border-radius: 4px;
  // margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    // padding-left: 18px;
    width: 62px;
    // background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    // background-size: 14px 14px;
    display: flex;
    align-items: center;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.rule_box {
  width: 860px;
  // height: 217px;
  background: #f8f9ff;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
  }
  &_bottom {
    margin-left: 7px;
  }
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2670fb;
            border-bottom: 1px solid #2670fb;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2670fb;
            border-left: 1px solid #2670fb;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #2670fb;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #2670fb;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 10px 30px;
      background: #f4f7ff;
      font-size: 13px;
      color: #333;
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #2670fb;
      }
    }
    .set {
      display: inline-block;
      // margin-top: 30px;
    }
    .desc {
      margin-left: 8px;
      color: #999;
      font-size: 13px;
      i {
        // color: #fe8f8a;
        // opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2670fb;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2670fb;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    // /deep/ .el-table .el-table__header-wrapper th .cell {
    //   text-align: center;
    //   font-weight: 500;
    // }
    // /deep/ .el-table .el-table__header-wrapper th {
    //   // border-right: 1px solid #f0f0f0;
    //   &:last-child {
    //     border-right: none;
    //   }
    // }
    // /deep/ .el-table--enable-row-transition .el-table__body td {
    //   text-align: center;
    //   // border-right: 1px solid #f0f0f0;
    //   &:last-child {
    //     border-right: none;
    //   }
    // }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #2670fb;
        border-bottom: 1px solid #2670fb;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #2670fb;
        border-left: 1px solid #2670fb;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
</style>
